import { Api, domain } from "@relode/core";

const function_name = (name: string) => `client.shared.services.${name}`;

export const normalizedJobTitleLookupService = {
    loadSuggestions: async (
        searchText: string
    ): Promise<domain.NormalizedJobTitle[]> => {
        try {
            const url = "market-research/job-titles/normalization";
            const result = await Api.url(url)
                .retries(3)
                .useSignal()
                .throwOnAbort()
                .track({
                    name: function_name(
                        "normalizedJobTitleLookupService.loadSuggestions"
                    ),
                    data: { searchText },
                })
                .body({ searchText })
                .post<domain.NormalizedJobTitle[]>();

            return result;
        } catch (err) {
            // fail silently
            // NOTE: ideally would display error in/near usage here
        }
        return [];
    },
};
